var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 37,
    height: 37,
    rx: 6,
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.6548C14.6503 11.6548 9.79892 14.5817 6.21909 19.3357C5.92697 19.7252 5.92697 20.2693 6.21909 20.6588C9.79892 25.4185 14.6503 28.3454 20 28.3454C25.3497 28.3454 30.2011 25.4185 33.7809 20.6645C34.073 20.275 34.073 19.7309 33.7809 19.3414C30.2011 14.5817 25.3497 11.6548 20 11.6548ZM20.3838 25.8767C16.8326 26.1001 13.9 23.1732 14.1234 19.6163C14.3066 16.6837 16.6836 14.3067 19.6162 14.1234C23.1674 13.9001 26.1 16.8269 25.8766 20.3838C25.6876 23.3107 23.3106 25.6877 20.3838 25.8767ZM20.2062 23.1618C18.2931 23.2821 16.7123 21.7069 16.8383 19.7939C16.9357 18.213 18.2187 16.9358 19.7995 16.8327C21.7126 16.7124 23.2934 18.2875 23.1674 20.2006C23.0643 21.7871 21.7813 23.0644 20.2062 23.1618Z",
    fill: "#4A9A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisble);
export default __webpack_public_path__ + "static/media/visble.8b1d7b789cb5fd1dc612553d6596b3d0.svg";
export { ForwardRef as ReactComponent };